import { Frequency } from '@vendasta/galaxy/frequency';
import { BillingPeriod, Cost, LineItem, Revenue, RevenueComponent, RevenuePeriod } from '@vendasta/sales-orders';
import { ItemRow } from './item-pricing-table.interface';

export function UpdateLineItemFromItemRow(lineItem: LineItem, item: ItemRow): LineItem {
  if (item.wholesalePricing?.usesVariablePricing) {
    lineItem.cost = new Cost({
      customPrice: item.wholesalePricing.frequencyPrices[0].price,
    });
  }

  const originalRevenueComponents = lineItem.currentRevenue?.revenueComponents || [];
  const revenueComponents: RevenueComponent[] = [];
  if (item.retailPricing) {
    revenueComponents.push(
      new RevenueComponent({
        value: item.retailPricing.price,
        period: convertFrequencyToRevenuePeriod(item.retailPricing.frequency),
        isStartingRevenue: originalRevenueComponents?.[0]?.isStartingRevenue,
      }),
    );
  }
  if (item.fees?.length) {
    item.fees
      .filter((fee) => Boolean(fee.retailAmount))
      .forEach((fee) => {
        revenueComponents.push(new RevenueComponent({ value: fee.retailAmount, period: RevenuePeriod.ONETIME }));
      });
  }
  lineItem.currentRevenue = new Revenue({
    revenueComponents: revenueComponents,
  });

  lineItem.quantity = item.quantity;
  if (item.billingTerm) {
    lineItem.billingPeriod = new BillingPeriod({
      startDate: item.billingTerm?.startDate,
      endDate: item.billingTerm?.endDate,
    });
  }

  return lineItem;
}

export function LineItemMatchesItemRow(lineItem: LineItem, item: ItemRow): boolean {
  const itemId = item?.itemId || '';
  const editionId = item.type === 'app' ? item?.edition?.editionId || '' : '';
  const lineItemAppId = lineItem?.appKey?.appId || '';
  const lineItemEditionId = lineItem?.appKey?.editionId || '';
  const lineItemPackageId = lineItem?.packageId || '';
  return (lineItemAppId === itemId && lineItemEditionId === editionId) || lineItemPackageId === itemId;
}

function convertFrequencyToRevenuePeriod(frequency: Frequency): RevenuePeriod {
  switch (frequency) {
    case Frequency.DAILY:
      return RevenuePeriod.DAILY;
    case Frequency.WEEKLY:
      return RevenuePeriod.WEEKLY;
    case Frequency.BI_WEEKLY:
      return RevenuePeriod.BIWEEKLY;
    case Frequency.ONE_TIME:
      return RevenuePeriod.ONETIME;
    case Frequency.MONTHLY:
      return RevenuePeriod.MONTHLY;
    case Frequency.YEARLY:
      return RevenuePeriod.YEARLY;
    default:
      return RevenuePeriod.ONETIME;
  }
}
